import type { ReactElement } from 'react';
const LABELS: Record<number, string> = {
  0: 'draft',
  1: 'published',
  2: 'active',
  3: 'disconnected',
  4: 'archived',
  5: 'error',
  6: 'unbound',
};

const COLORS: Record<number, string> = {
  0: 'bg-slate-700 text-slate-200',
  1: 'bg-blue-700 text-blue-100',
  2: 'bg-emerald-700 text-emerald-100',
  3: 'bg-amber-700 text-amber-100',
  4: 'bg-slate-600 text-slate-200',
  5: 'bg-rose-700 text-rose-100',
  6: 'bg-slate-500 text-slate-200',
};

export function StatusBadge({ status }: { status: number }): ReactElement {
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${
        COLORS[status] ?? 'bg-slate-700 text-slate-200'
      }`}
    >
      {LABELS[status] ?? 'unknown'}
    </span>
  );
}
